<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script>
export default {
    name: 'fade-transition',
    props: {
        /**
         * Whether the component should be a `transition-group` component.
         */
    },
}
</script>

<template>
    <transition
        v-bind="$attrs"
        enter-active-class="transition-fade--in"
        leave-active-class="transition-fade--out"
        name="transition-fade"
    >
        <slot></slot>
    </transition>
</template>

<style lang="scss">
@use '@bam/scss' as *;

@keyframes transition-fade--in {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes transition-fade--out {
    from { opacity: 1; }
    to { opacity: 0; }
}

.transition-fade--in {
    animation-name: transition-fade--in;
    animation-duration: v(duration-fade-in);
}

.transition-fade--out {
    animation-name: transition-fade--out;
    animation-duration: v(duration-fade-out);
}

.transition-fade-move {
    transition: transform v(duration-default) v(easing-default);
}
</style>
